import { TIsNewPaymentProvider } from "../interface/IPaymentProvider";

export enum EPaymentProviderResponse {
    STANCER = "STANCER",
    ELAVON = "ELAVON",
}

export interface IPaymentProviderResponse {
    paymentProvider: EPaymentProviderResponse;
}

export const getResponseToState = (response: IPaymentProviderResponse): TIsNewPaymentProvider =>
    response.paymentProvider === EPaymentProviderResponse.STANCER;
